import { JOB_TYPE } from '../../../common/constants';
import { PaymentFrequency } from '../../../common/interfaces/entities';
import { JobResponse } from '../../../common/interfaces/responses';
import { BonusFrequency, SalaryBasic, SalaryBonus } from '../common/constants';
import { sanitizeSalaryByCommitmentType } from '../common/helper';

export const getSalaryStateFromResponse = (response: JobResponse) => {
  const jobSalary = (response as JobResponse).data.salaries;

  const basicSalary = jobSalary
    ? (jobSalary.find(
        salary => salary.salaryType === 'BASIC'
      ) as SalaryBasic & { paymentFrequency?: string })
    : null;

  const bonusSalary = jobSalary
    ? (jobSalary.find(salary => salary.salaryType === 'BONUS') as SalaryBonus)
    : null;

  const minSalaryAmount = basicSalary?.minAmount ?? null;

  return {
    addBonus: Boolean(bonusSalary),
    salaryRate: basicSalary?.salaryMode || null,
    salaryMode: bonusSalary?.salaryMode || BonusFrequency.MONTH,
    minSalaryAmount,
    maxSalaryAmount: basicSalary?.maxAmount || null,
    minBonusAmount: bonusSalary?.minAmount || 0,
    maxBonusAmount: bonusSalary?.maxAmount || 0,
    shouldShowSalary: response.data.shouldShowSalary,
    CurrencyCode: basicSalary?.CurrencyCode,
    ...(basicSalary?.paymentFrequency && {
      paymentFrequency: basicSalary.paymentFrequency as PaymentFrequency,
    }),
    showPaymentFrequency: Boolean(basicSalary?.paymentFrequency),
  };
};

export const getSanitizedSalaryState = (
  response: JobResponse,
  jobType: JOB_TYPE
) => {
  const salaryState = getSalaryStateFromResponse(response);

  if (!salaryState.showPaymentFrequency) {
    return salaryState;
  }

  const { paymentFrequency, salaryRate } = sanitizeSalaryByCommitmentType(
    jobType,
    salaryState.paymentFrequency,
    salaryState.salaryRate
  );

  return { ...salaryState, paymentFrequency, salaryRate };
};
